var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("Game", { attrs: { "show-game": _vm.showApp && _vm.mapLoaded } }),
      _vm._v(" "),
      !_vm.showApp
        ? _c(
            "div",
            {
              class: {
                "show-splash": _vm.showSplash,
                "hide-splash": !_vm.showSplash
              },
              attrs: { id: "splash" }
            },
            [_c("h1", [_vm._v(" Retro Game Jam 2021 ")])]
          )
        : !_vm.showSplash && !_vm.gameStarted
        ? _c(
            "div",
            {
              staticClass: "main-container",
              class: { "show-main": _vm.showApp && _vm.mapLoaded }
            },
            [
              _c("div", { staticClass: "inner-container" }, [
                _c("div", { staticClass: "half-vert top" }, [
                  _c("div", { staticClass: "game-title" }, [
                    _c("img", {
                      attrs: {
                        id: "logo",
                        src: require("./assets/sneslogo.png").default
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _vm._m(0)
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "half-vert bottom" }, [
                  _c("div", { staticClass: "option-container" }, [
                    !_vm.chosingName
                      ? _c("div", { staticClass: "btn-options" }, [
                          _c(
                            "div",
                            {
                              staticClass: "play-btn",
                              on: {
                                click: function($event) {
                                  return _vm.startChosingName()
                                }
                              }
                            },
                            [_vm._v("\n              Start Game\n            ")]
                          )
                        ])
                      : _c("div", { staticClass: "name-enter-wrapper" }, [
                          _c("div", {
                            staticClass: "cancel-btn",
                            on: {
                              click: function($event) {
                                _vm.chosingName = false
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("h2", [_vm._v(" What is your name? ")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.chosenName,
                                expression: "chosenName"
                              }
                            ],
                            ref: "entername",
                            attrs: { type: "text" },
                            domProps: { value: _vm.chosenName },
                            on: {
                              keydown: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.startGame(true)
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.chosenName = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "rdy-btn-wrapper" }, [
                            _c(
                              "div",
                              {
                                staticClass: "play-btn",
                                class: {
                                  "ready-btn": _vm.validChosenName,
                                  "disabled-btn": !_vm.validChosenName
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.startGame(true)
                                  }
                                }
                              },
                              [_vm._v(" Ready! ")]
                            )
                          ])
                        ])
                  ])
                ])
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "credits" }, [
      _c(
        "a",
        { attrs: { href: "http://www.fordesoft.com/", target: "_blank" } },
        [_vm._v("Graphics - Josh")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: { href: "https://twitter.com/lawofsavages", target: "_blank" }
        },
        [_vm._v("Code - visgotti ")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            href:
              "https://soundcloud.com/user-794447480?p=a&c=1&utm_source=other&utm_medium=text&utm_campaign=social_sharing"
          }
        },
        [_vm._v("Music - FranciosBL")]
      ),
      _vm._v(" "),
      _c("a", { attrs: { href: "https://www.soundcloud.com/rosko-vair" } }, [
        _vm._v("Music - Rosko")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }